import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { complianceStageValidation } from "../../../schemas";
import { Form } from "react-bootstrap";
import {
  POST_UPDATE_RECRUITMENT_CANDIDATE_URL,
  UPLOAD_REFERENCE_DOCUMENT_URL,
  ADMIN_AUTH_TOKEN,
  BASE_URL,
  ADMIN_ID
} from "../../../env";
import {
  postRecords,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
  catchAsync,
} from "../../../helper/helper";
import TextArea from "../../../components/forms-fields/TextArea";

function ComplianceProcessPopup({ recCandidateDetail, subModalViewCarePlans }) {
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [fileSizeError, setFileSizeError] = useState({});
  const [uploadedFileLink, setUploadedFileLink] = useState(false);
  const [isRecrUserData, setIsRecrUserData] = useState(false);
  const [commentBox, setCommentBox] = useState("");
  const [trainingStatus, setTrainingStatus] = useState(false);
  const handleClose = () => {
    subModalViewCarePlans(subModalViewCarePlans);
  };

  const [complianceFormFields] = useState([
    { id: 1, name: "references", label: "References", documentEnum: "references" },
    { id: 2, name: "bankDetailsForm", label: "Bank Details form", documentEnum: "bankDetailsForm" },
    { id: 3, name: "personalDetailsForm", label: "Personal Details form", documentEnum: "personalDetailsForm" },
    { id: 4, name: "hourOptOutForm", label: "48-hour Opt out form", documentEnum: "hourOptOutForm" },
    { id: 5, name: "healthDeclaration", label: "Health declaration", documentEnum: "healthDeclaration" },
    { id: 5, name: "equalOpportunities", label: "Equal opportunities", documentEnum: "equalOpportunities" },
    { id: 5, name: "BYODSignedDeclaration", label: "BYOD signed declaration", documentEnum: "BYODSignedDeclaration" },
    { id: 5, name: "othercomplianceDoc", label: "Other Document", documentEnum: "othercomplianceDoc" },
  ]);

  const [complianceUploadedDoc, setComplianceUploadedDoc] = useState([
    { documentEnum: "references", path: "", title: "References", docType: "complianceDoc" },
    { documentEnum: "bankDetailsForm", path: "", title: "Bank Details form", docType: "complianceDoc" },
    { documentEnum: "personalDetailsForm", path: "", title: "Personal Details Form", docType: "complianceDoc" },
    { documentEnum: "hourOptOutForm", path: "", title: "48-hour Opt out form", docType: "complianceDoc" },
    { documentEnum: "healthDeclaration", path: "", title: "Health declaration", docType: "complianceDoc" },
    { documentEnum: "equalOpportunities", path: "", title: "Equal opportunities", docType: "complianceDoc" },
    { documentEnum: "BYODSignedDeclaration", path: "", title: "BYOD signed declaration", docType: "complianceDoc" },
    { documentEnum: "othercomplianceDoc", path: "", title: "Other Document", docType: "complianceDoc" },
  ]);

  useEffect(() => {

    if (recCandidateDetail?.complianceDoc?.length > 0) {
      setComplianceUploadedDoc(recCandidateDetail.complianceDoc);
    }
  }, [recCandidateDetail]);

  const [suFormData, setSuFormData] = useState({
    recruitId: recCandidateDetail?._id || "",
    references: recCandidateDetail.complianceDoc[0]?.path || "",
    bankDetailsForm: recCandidateDetail.complianceDoc[1]?.path || "",
    personalDetailsForm: recCandidateDetail.complianceDoc[2]?.path || "",
    hourOptOutForm: recCandidateDetail.complianceDoc[3]?.path || "",
    healthDeclaration: recCandidateDetail.complianceDoc[4]?.path || "",
    equalOpportunities: recCandidateDetail.complianceDoc[5]?.path || "",
    BYODSignedDeclaration: recCandidateDetail.complianceDoc[6]?.path || "",
    trainingCompletedPercent: trainingStatus,
    commentBox: "",
    docType: "complianceDoc",
  });
  // console.log("🚀 ~ ComplianceProcessPopup ~ suFormDatasuFormDatasuFormData:", suFormData)
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: complianceStageValidation,
    onSubmit: async (values) => {
      try {
        setIsSubmitButtonClicked(true);
        await postAddCarePlansFormData(values);
      } catch (error) {

      }
    },
  });

  const processPostRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      setIsRecrUserData(true);
      toastErrorMessages(toast.error, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);
    } else if (method === "postAddCarePlansFormData" && data?.status === isSuccess) {
      setIsRecrUserData(true);
      toastSuccessMessages(toast.success, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);
      setTimeout(() => {
        handleClose();
      }, 2000);
    }
  };

  const postAddCarePlansFormData = catchAsync(async (req, res) => {
    const updateValues = {
      ...values,
      complianceDoc: complianceUploadedDoc,
      notes: [
        ...recCandidateDetail?.notes,
        ...(commentBox !== "" ? [{
          staffId: ADMIN_ID,
          note: commentBox,
          process: recCandidateDetail?.processStatus,
        }] : [])
      ],
    };

    const response = await postRecords(POST_UPDATE_RECRUITMENT_CANDIDATE_URL, updateValues);
    setIsSubmitButtonClicked(false);
    processPostRecords("postAddCarePlansFormData", response);
  });

  const handleFileUpload = async (e, documentEnum, settingTheArray) => {
    setIsSubmitButtonClicked(true);
    try {
      const file = e.target.files[0];
      const fileName = file.name;
      const fileType = file.type;
      const fileSize = file.size;

      // Check file size (5MB = 1048576 bytes)
      if (fileSize > 5 * 1024 * 1024) {
        alert('File size exceeds 5MB');
        setFileSizeError(prev => ({ ...prev, [documentEnum]: true }));
        setIsSubmitButtonClicked(false);
        return;
      } else {
        // Clear any previous error for this field
        setFileSizeError(prev => ({ ...prev, [documentEnum]: false }));
      }

      // Check file type
      const acceptedFileTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'image/jpeg',
        'image/jpg',
        'image/svg+xml'
      ];

      if (acceptedFileTypes.includes(fileType)) {
        const fileData = new FormData();
        fileData.append('attachements', file);

        const apiResponse = await fetch(UPLOAD_REFERENCE_DOCUMENT_URL, {
          method: 'POST',
          body: fileData,
          headers: {
            Authorization: `Bearer ${ADMIN_AUTH_TOKEN}`,
          },
        });

        const resultResponse = await apiResponse.json();
        // console.log("🚀 ~ handleFileUpload ~ resultResponse:", resultResponse)
        const fileLink = `${resultResponse?.data[0]?.fileNameInDirectory}`;
        setUploadedFileLink(fileLink);

        settingTheArray((prevValues) =>
          prevValues.map((doc) =>
            doc.documentEnum === documentEnum ? { ...doc, path: fileLink, docType: "complianceDoc" } : doc
          )
        );
      } else {
        alert('Unsupported file format');
      }

      setIsSubmitButtonClicked(false);
    } catch (error) {
      console.error('Error uploading file:', error);
      setIsSubmitButtonClicked(false);
    }
  };

  useEffect(() => {
    setValues((prevValues) => ({
      ...prevValues,
      complianceDoc: complianceUploadedDoc,
    }));
  }, [complianceUploadedDoc]);

  return (
    <>
      <main>
        <form onSubmit={handleSubmit} encType="multipart/form-data">

          <div className="row">

            {recCandidateDetail?.processStatus === 'compliance' &&
              recCandidateDetail.complianceDoc.length >= 5 && (
                <>
                  <div className="col-md-12">
                    <p>
                      <strong>Attached Documents</strong>
                    </p>
                    <div className="attachedDocumentWrapper">
                      {
                        complianceUploadedDoc.map((item, index) => (

                          <div key={index} className="alert alert-secondary" role="alert">
                            <a target="_blank" href={`${BASE_URL}${item?.path}`}>{item?.title}</a>
                          </div>



                        ))
                      }
                    </div>
                  </div>
                </>
              )}

            <div className="col-md-12 mt-5">
              <p>
                <strong>Attach required documents</strong>
                <small>Please upload a file that is 5MB or smaller.</small>
              </p>
            </div>
            {complianceFormFields.map((item, index) => (
              <div key={index} className="col-md-12">
                <div className="form-group">
                  <input
                    name={item.name}
                    id={item.name}
                    type="file"
                    accept=".jpg,.jpeg,.pdf,.doc,.docx,.svg"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                      handleFileUpload(e, item.documentEnum, setComplianceUploadedDoc);
                    }}
                  />
                  <label htmlFor={item.name} className="floatingLabel">
                    {item.label}
                    {
                      item.documentEnum !== "othercomplianceDoc" && (
                        <span className="text-danger">*</span>
                      )
                    }
                  </label>
                  {errors[item.name] && touched[item.name] && (
                    <div className="validationError">
                      <div className="text-danger">{errors[item.name]}</div>
                    </div>
                  )}
                  {fileSizeError[item?.documentEnum] && (
                    <div className="validationError">
                      <div className="text-danger">
                        Error: File size exceeds the 5MB limit. Please upload a smaller file.
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}

            <div className="col-md-12 mb-3">
              <Form.Check
                type="checkbox"
                id={'trainingCompletedPercent'}
                name={'trainingCompletedPercent'}
                checked={values?.trainingCompletedPercent}
                onChange={(e) => {
                  setFieldValue('trainingCompletedPercent', e.target.checked);
                  setTrainingStatus(!trainingStatus);
                }}
                label={'Please tick to confirm that 50% of online training has been completed '}
              />
              {errors.trainingCompletedPercent && touched.trainingCompletedPercent && (
                <div className="validationError">
                  <div className="text-danger">{errors.trainingCompletedPercent}</div>
                </div>
              )}
            </div>

            <div className="col-md-12">
              <TextArea
                name="commentBox"
                value={commentBox}
                onChange={(e) => { setCommentBox(e.target.value); handleChange(e); }}
                onBlur={handleBlur}
                cols={5}
                rows={5}
                labelText="Notes"

              />
            </div>
          </div>
          <div className="formActionButtons">
            {isSubmitButtonClicked ? (
              <Button
                onClick={handleClose}
                className="btn-sm"
                variant="primary"
                disabled
              >
                Loading...
              </Button>
            ) : (
              <Button className="btn-sm" variant="primary" type="submit">
                Save
              </Button>
            )}
            <span
              onClick={handleClose}
              className="btn btn-sm btn-outline-primary"
            >
              Close
            </span>
          </div>
        </form>
      </main>
      {isRecrUserData && <ToastContainer />}
    </>
  );
}

export default ComplianceProcessPopup;
